<app-spu-form-wrapper
  data-testid="ordinary-spu-add-form-wrapper"
  [config]="config"
  [editMode]="false"
  [viewMode]="false"
  [showFaq]="true"
></app-spu-form-wrapper>
